var map = {
	"./Anae.js": "JkmH",
	"./Card.js": "7T+o",
	"./Common.js": "odQB",
	"./DS.js": "+rNI",
	"./Diab.js": "fvjn",
	"./EBM.js": "qu3q",
	"./ER.js": "6Y8h",
	"./Endocrine.js": "Wwnz",
	"./GD.js": "JSPb",
	"./GIT.js": "BOps",
	"./HD.js": "aWUP",
	"./Hema.js": "J0RM",
	"./Hepatology.js": "6Nzv",
	"./ID.js": "C+LO",
	"./Neuro.js": "7X/r",
	"./NewFormulas.js": "bJGw",
	"./Nurse.js": "NT1n",
	"./ObGyn.js": "Z9I/",
	"./Onco.js": "4Pog",
	"./Orthopaedics.js": "YU6D",
	"./Pedi.js": "wBG7",
	"./Pulm.js": "8/uO",
	"./RI.js": "kV/N",
	"./Renal.js": "L5Ri",
	"./Trauma.js": "RY4C",
	"./Urology.js": "kqgE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VVGu";


//////////////////
// WEBPACK FOOTER
// ./src/utils/category \.js$
// module id = VVGu
// module chunks = 2